import { IGoal } from "motw_core/Entity/IGoal";
import * as React from "react";
import { WithAnimatedProgressBarAsync } from "source/app/presentation/Header/ProgressBar/LevelProgressBar/WithAnimatedProgressBar";
import { AdjustWeeklyRatesForGoalsAsync } from "source/app/presentation/MainPanel/Goals/GoalCards/AdjustWeeklyRates/Helpers/AdjustWeeklyRatesForGoals";
import { IsGoalDaysLeftBad } from "source/app/services/Goals/GoalBadgeCalculations";
import { Style, StyleClass } from "../../../../Shared/Styles/CSS";

export function AdjustWeeklyRates({ goalsToShow }: { goalsToShow: IGoal[] }) {
    const goalsToAdjust = goalsToShow.filter((goal) =>
        IsGoalDaysLeftBad(goal.daysleft)
    );

    if (goalsToAdjust.length === 0) {
        return null;
    }

    React.useEffect(() => {
        if (goalsToAdjust.length > 0) {
            WithAnimatedProgressBarAsync(() =>
                AdjustWeeklyRatesForGoalsAsync(goalsToAdjust)
            );
        }
    }, [goalsToAdjust.length]);

    const adjustWeeklyRatesStyleClass = StyleClass(`adjustWeeklyRatesLink`, {
        color: `white`,
        marginBottom: `10px`,
    });

    return (
        <div {...Style(`adjustWeeklyRatesLinkContainer`, { width: `100%` })}>
            <div className={adjustWeeklyRatesStyleClass}>
                Adjusting weekly rates...
            </div>
        </div>
    );
}
